export const currencyCodes: Record<string, { exponent: string; name: string }> = {
	AED: {
		name: 'UAE Dirham',
		exponent: '2',
	},
	ALL: {
		name: 'Albanian Lek',
		exponent: '2',
	},
	AMD: {
		name: 'Armenian Dram',
		exponent: '2',
	},
	ANG: {
		name: 'Antillian Guilder',
		exponent: '2',
	},
	ARS: {
		name: 'Argentine Peso',
		exponent: '2',
	},
	AUD: {
		name: 'Australian Dollar',
		exponent: '2',
	},
	AWG: {
		name: 'Aruban Guilder',
		exponent: '2',
	},
	AZN: {
		name: 'Azerbaijani manat',
		exponent: '2',
	},
	BAM: {
		name: 'Bosnia and Herzegovina Convertible Marks',
		exponent: '2',
	},
	BBD: {
		name: 'Barbados Dollar',
		exponent: '2',
	},
	BDT: {
		name: 'Bangladesh Taka',
		exponent: '2',
	},
	BGL: {
		name: 'Bulgaria Lev',
		exponent: '2',
	},
	BGN: {
		name: 'New Bulgarian Lev',
		exponent: '2',
	},
	BHD: {
		name: 'Bahraini Dinar',
		exponent: '3',
	},
	BMD: {
		name: 'Bermudian Dollar',
		exponent: '2',
	},
	BND: {
		name: 'Brunei Dollar',
		exponent: '2',
	},
	BOB: {
		name: 'Bolivia Boliviano',
		exponent: '2',
	},
	BRL: {
		name: 'Brazilian Real',
		exponent: '2',
	},
	BSD: {
		name: 'Bahamian Dollar',
		exponent: '2',
	},
	BWP: {
		name: 'Botswana Pula',
		exponent: '2',
	},
	BYN: {
		name: 'New Belarusian Ruble',
		exponent: '2',
	},
	BZD: {
		name: 'Belize Dollar',
		exponent: '2',
	},
	CAD: {
		name: 'Canadian Dollar',
		exponent: '2',
	},
	CHF: {
		name: 'Swiss Franc',
		exponent: '2',
	},
	CLP: {
		name: 'Chilean Peso',
		exponent: '2',
	},
	CNY: {
		name: 'Yuan Renminbi',
		exponent: '2',
	},
	COP: {
		name: 'Colombian Peso',
		exponent: '2',
	},
	CRC: {
		name: 'Costa Rican Colon',
		exponent: '2',
	},
	CSD: {
		name: 'Serbian Dinar',
		exponent: '2',
	},
	CVE: {
		name: 'Cape Verdi Escudo',
		exponent: '0',
	},
	CZK: {
		name: 'Czech Koruna',
		exponent: '2',
	},
	DJF: {
		name: 'Djibouti Franc',
		exponent: '0',
	},
	DKK: {
		name: 'Danish Krone',
		exponent: '2',
	},
	DOP: {
		name: 'Dominican Republic Peso',
		exponent: '2',
	},
	DZD: {
		name: 'Algerian Dinar',
		exponent: '2',
	},
	LAK: {
		name: 'Laos Kip',
		exponent: '2',
	},
	LBP: {
		name: 'Lebanese Pound',
		exponent: '2',
	},
	LKR: {
		name: 'Sri Lanka Rupee',
		exponent: '2',
	},
	LTL: {
		name: 'Lithuanian Litas',
		exponent: '2',
	},
	LVL: {
		name: 'Latvian Lats',
		exponent: '2',
	},
	LYD: {
		name: 'Libyan Dinar',
		exponent: '3',
	},
	MAD: {
		name: 'Moroccan Dirham',
		exponent: '2',
	},
	MDL: {
		name: 'Moldovia Leu',
		exponent: '2',
	},
	MNT: {
		name: 'Mongolia Tugrik',
		exponent: '2',
	},
	MOP: {
		name: 'Macau Pataca',
		exponent: '2',
	},
	MRO: {
		name: 'Mauritania Ouguiya',
		exponent: '1',
	},
	MUR: {
		name: 'Mauritius Rupee',
		exponent: '2',
	},
	MVR: {
		name: 'Maldives Rufiyaa',
		exponent: '2',
	},
	MWK: {
		name: 'Malawi Kwacha',
		exponent: '2',
	},
	MXN: {
		name: 'Mexican Peso',
		exponent: '2',
	},
	MXP: {
		name: 'Mexican Peso',
		exponent: '2',
	},
	MYR: {
		name: 'Malaysian Ringgit',
		exponent: '2',
	},
	NAD: {
		name: 'Namibian Dollar',
		exponent: '2',
	},
	NGN: {
		name: 'Nigerian Naira',
		exponent: '2',
	},
	NIO: {
		name: 'Nicaragua Cordoba Oro',
		exponent: '2',
	},
	NOK: {
		name: 'Norwegian Krone',
		exponent: '2',
	},
	NPR: {
		name: 'Nepalese Rupee',
		exponent: '2',
	},
	NZD: {
		name: 'New Zealand Dollar',
		exponent: '2',
	},
	OMR: {
		name: 'Rial Omani',
		exponent: '3',
	},
	PAB: {
		name: 'Panamanian Balboa',
		exponent: '2',
	},
	PEN: {
		name: 'Peruvian Nuevo Sol',
		exponent: '2',
	},
	PGK: {
		name: 'New Guinea Kina',
		exponent: '2',
	},
	PHP: {
		name: 'Philippine Peso',
		exponent: '2',
	},
	PKR: {
		name: 'Pakistan Rupee',
		exponent: '2',
	},
	PLN: {
		name: 'New Polish Zloty',
		exponent: '2',
	},
	PYG: {
		name: 'Paraguay Guarani',
		exponent: '0',
	},
	QAR: {
		name: 'Qatari Rial',
		exponent: '2',
	},
	ROL: {
		name: 'Romanian Lei',
		exponent: '2',
	},
	RON: {
		name: 'New Romanian Lei',
		exponent: '2',
	},
	RSD: {
		name: 'Serbian Dinar',
		exponent: '2',
	},
	RUB: {
		name: 'Russian Ruble',
		exponent: '2',
	},
	EEK: {
		name: 'Estonian Krone',
		exponent: '2',
	},
	EGP: {
		name: 'Egyptian Pound',
		exponent: '2',
	},
	ETB: {
		name: 'Ethiopian Birr',
		exponent: '2',
	},
	EUR: {
		name: 'Euro',
		exponent: '2',
	},
	FJD: {
		name: 'Fiji Dollar',
		exponent: '2',
	},
	FKP: {
		name: 'Falkland Islands Pound',
		exponent: '2',
	},
	GBP: {
		name: 'Pound Sterling',
		exponent: '2',
	},
	GEL: {
		name: 'Georgian Lari',
		exponent: '2',
	},
	GHC: {
		name: 'Ghanaian Cedi (2nd)',
		exponent: '0',
	},
	GHS: {
		name: 'Ghanaian Cedi (3rd)',
		exponent: '2',
	},
	GIP: {
		name: 'Gibraltar Pound',
		exponent: '2',
	},
	GMD: {
		name: 'Gambia Delasi',
		exponent: '2',
	},
	GNF: {
		name: 'Guinea Franc',
		exponent: '0',
	},
	GTQ: {
		name: 'Guatemala Quetzal',
		exponent: '2',
	},
	GYD: {
		name: 'Guyanese Dollar',
		exponent: '2',
	},
	HKD: {
		name: 'Hong Kong Dollar',
		exponent: '2',
	},
	HNL: {
		name: 'Honduras Lempira',
		exponent: '2',
	},
	HRK: {
		name: 'Croatia Kuna',
		exponent: '2',
	},
	HTG: {
		name: 'Haitian Gourde',
		exponent: '2',
	},
	HUF: {
		name: 'Hungarian Forint',
		exponent: '2',
	},
	IDR: {
		name: 'Indonesian Rupiah',
		exponent: '0',
	},
	ILS: {
		name: 'New Israeli Scheqel',
		exponent: '2',
	},
	INR: {
		name: 'Indian Rupee',
		exponent: '2',
	},
	ISK: {
		name: 'Iceland Krona',
		exponent: '2',
	},
	JMD: {
		name: 'Jamaican Dollar',
		exponent: '2',
	},
	JOD: {
		name: 'Jordanian Dinar',
		exponent: '3',
	},
	JPY: {
		name: 'Japanese Yen',
		exponent: '0',
	},
	KES: {
		name: 'Kenyan Shilling',
		exponent: '2',
	},
	KGS: {
		name: 'Kyrgyzstan Som',
		exponent: '2',
	},
	KHR: {
		name: 'Cambodia Riel',
		exponent: '2',
	},
	KMF: {
		name: 'Comoro Franc',
		exponent: '0',
	},
	KRW: {
		name: 'South-Korean Won',
		exponent: '0',
	},
	KWD: {
		name: 'Kuwaiti Dinar',
		exponent: '3',
	},
	KYD: {
		name: 'Cayman Islands Dollar',
		exponent: '2',
	},
	KZT: {
		name: 'Kazakhstani Tenge',
		exponent: '2',
	},
	RWF: {
		name: 'Rwanda Franc',
		exponent: '0',
	},
	SAR: {
		name: 'Saudi Riyal',
		exponent: '2',
	},
	SBD: {
		name: 'Solomon Island Dollar',
		exponent: '2',
	},
	SCR: {
		name: 'Seychelles Rupee',
		exponent: '2',
	},
	SEK: {
		name: 'Swedish Krone',
		exponent: '2',
	},
	SGD: {
		name: 'Singapore Dollar',
		exponent: '2',
	},
	SHP: {
		name: 'St. Helena Pound',
		exponent: '2',
	},
	SKK: {
		name: 'Slovak Koruna',
		exponent: '2',
	},
	SLL: {
		name: 'Sierra Leone',
		exponent: '2',
	},
	SOS: {
		name: 'Somalia Shilling',
		exponent: '2',
	},
	STD: {
		name: 'Sao Tome & Principe Dobra',
		exponent: '2',
	},
	SVC: {
		name: 'El Salvador Colón',
		exponent: '2',
	},
	SZL: {
		name: 'Swaziland Lilangeni',
		exponent: '2',
	},
	THB: {
		name: 'Thai Baht',
		exponent: '2',
	},
	TND: {
		name: 'Tunisian Dinar',
		exponent: '3',
	},
	TOP: {
		name: "Tonga Pa'anga",
		exponent: '2',
	},
	TRY: {
		name: 'New Turkish Lira',
		exponent: '2',
	},
	TTD: {
		name: 'Trinidad & Tobago Dollar',
		exponent: '2',
	},
	TWD: {
		name: 'New Taiwan Dollar',
		exponent: '2',
	},
	TZS: {
		name: 'Tanzanian Shilling',
		exponent: '2',
	},
	UAH: {
		name: 'Ukraine Hryvnia',
		exponent: '2',
	},
	UGX: {
		name: 'Uganda Shilling',
		exponent: '0',
	},
	USD: {
		name: 'US Dollars',
		exponent: '2',
	},
	UYU: {
		name: 'Peso Uruguayo',
		exponent: '2',
	},
	UZS: {
		name: 'Uzbekistani Som',
		exponent: '2',
	},
	VEF: {
		name: 'Venezuelan Bolívar',
		exponent: '2',
	},
	VND: {
		name: 'Vietnamese New Dong',
		exponent: '0',
	},
	VUV: {
		name: 'Vanuatu Vatu',
		exponent: '0',
	},
	WST: {
		name: 'Samoan Tala',
		exponent: '2',
	},
	XAF: {
		name: 'CFA Franc BEAC',
		exponent: '0',
	},
	XCD: {
		name: 'East Carribean Dollar',
		exponent: '2',
	},
	XOF: {
		name: 'CFA Franc BCEAO',
		exponent: '0',
	},
	XPF: {
		name: 'CFP Franc',
		exponent: '0',
	},
	YER: {
		name: 'Yemeni Rial',
		exponent: '2',
	},
	ZAR: {
		name: 'South African Rand',
		exponent: '2',
	},
	ZMW: {
		name: 'Zambia Kwacha',
		exponent: '2',
	},
};

export function amountToMinorUnits(value: number, currency: string): number {
	return value * Math.pow(10, Number(currencyCodes[currency]!.exponent));
}
